import React from 'react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import ExcludedAccountsVM from './ExcludedAccountsVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import ExcludedAccountLookup from '../Models/Lookups/ExcludedAccountLookup';
import ManageExclusionAccountsComponent from '../Components/ManageExclusionAccountsComponent';
import ClientAccountMappingVM from '../../ClientAccountMapping/Views/ClientAccountMappingVM';
import { ExcludedAccounts } from '../../../AccessControl/Models/Commands/Security/Roles';

interface IExcludedAccountsViewProps {
    viewModel: ExcludedAccountsVM;
    clientAccountVM: ClientAccountMappingVM;
}

@observer
export default class ExcludedAccountsView extends React.Component<IExcludedAccountsViewProps> {

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <>
                {viewModel.showManageExcludedAccountComponent &&
                    <ManageExclusionAccountsComponent
                        viewModel={viewModel.manageExclusionAccountComponentVM}
                        onSave={() => this.props.clientAccountVM.saveExcludedAccount(viewModel.manageExclusionAccountComponentVM.managedExclusionAccount)}
                        onCancel={() => viewModel.cancel()} />
                }
                {!viewModel.showManageExcludedAccountComponent && viewModel.authorisationService.hasRole(ExcludedAccounts.Access) &&
                    <Neo.Card title={TextConstants.Titles.ExcludedAccounts} className="m-1">
                        {viewModel.authorisationService.hasRole(ExcludedAccounts.AddNew) &&
                            <div className="row">
                                <div className="col text-right pt-0 pb-3">
                                    <Neo.Button
                                        onClick={() => viewModel.addNewExclusionAccount()}
                                        className="btn btn-default" variant="primary">
                                        {TextConstants.Buttons.AddNewExcludedAccount}
                                    </Neo.Button>
                                </div>
                            </div>
                        }
                        <>
                            <Neo.Form model={viewModel.excludedAccountSearchCriteria} onSubmit={() => viewModel.excludedAccountSearchCriteria.meta.searchCriteria.value === "" ?   viewModel.clearSearch() : viewModel.pageManager.refreshData()}>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={viewModel.excludedAccountSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchExcludedAccounts}
                                    append={
                                        <Neo.Button isSubmit variant="primary">
                                            <i className={`${viewModel.excludedAccountSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                        </Neo.Button>
                                    }>
                                </Neo.FormGroup>
                            </Neo.Form>
                        </>

                        <Neo.Pager pageManager={viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                            <div className="horizontalScroll inner-container">
                                <NeoGrid.Grid<ExcludedAccountLookup> className={"table-striped"}>
                                    {(item, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column display={meta.brokerName} label={TextConstants.Labels.Broker} />
                                            <NeoGrid.Column display={meta.accountNumber} />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </div>
                        </Neo.Pager>
                    </Neo.Card>}
            </>
        );
    }
}